/// <reference path="_references.ts"/>

var chatURL: string;

module App.Chat {
	angular
		.module('chat', [
			'vxWamp',
		])
		.config(['$wampProvider', 'LoginServiceProvider', function($wampProvider: any, LoginServiceProvider: any) {
			const LoginService = LoginServiceProvider.$get();

			$wampProvider.init({
				url: chatURL,
				realm: 'ws',
				authid: LoginService.giveToken(),
				authmethods: ['token'],
				onchallenge: function(session: any, method: string) {
					if(method === 'token') {
						return LoginService.giveToken();
					}
					throw "NotImplementedError";
				}
			});
		}])
		.controller('ChatController', App.DefaultFactory(ChatController))
		.directive('chat', App.DefaultFactory(ChatDirective))
		.directive('chatMessagesWrapper', App.DefaultFactory(ChatMessagesWrapperDirective))
		.factory('ChatService', App.DefaultFactory(ChatService));
}